import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'enterpriseButtonClick',
  'choosePlan',
  'pricingPageShown',
  'moreMinutesHomePageClick',
  'moreMinutesAccountClick',
  'buyAdditionalMinutesAccount',
  'upgradeCreatorClick',
  'upgradeCreatorProClick',
  'upgradeBusinessClick',
  'switchAnnualCreatorClick',
  'switchAnnualCreatorProClick',
  'switchAnnualBusinessClick',
  'pricingSwitchAnnual',
  'pricingSwitchMonthly',
  'bundleSwitchCreatorPro',
  'bundleSwitchBusiness',
  'pricingVisitedPaidUser',
  'minutesModalViewPlansClick',
  'payLessMinutesButton',
  'buyMinutesModalShown',
  'buyMinutesButtonHomePageClick',
] as const;

export const pricingEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
